const isRealTest = false
const isReal = typeof window !== "undefined" && window.location.href.indexOf("janapost") >= 0
const isStage = typeof window !== "undefined" && window.location.href.indexOf("marketing-stage.janatest.kz") >= 0
const isTest = typeof window !== "undefined" && window.location.href.indexOf("marketing-dev.janatest.kz") >= 0

function getBaseUrl() {
    const devUrl = "https://api-dev1.janatest.kz/"
    const stageUrl = "https://api-stage.janatest.kz/"
    const realUrl = "https://admin-api.janapost.kz/"

    if (isReal || isRealTest) {
        return realUrl
    } else if (isStage) {
        return stageUrl
    } else if (isTest) {
        return devUrl
    } 
    // #TODO add switch input when runs in localhost user can swithch with stage and dev
    return stageUrl;
}

const baseUrl = {
    nakedBaseURL: getBaseUrl(),
    baseURL: getBaseUrl() + "service/",
    bonusBaseURL: getBaseUrl() + "bonus-service/",
}

export default baseUrl
